import { IconProps } from "@/icons/icon";
import { memo } from "react";
import { rem } from "@mantine/core";

export const MicrochipAI = memo(function MicrochipAI({
  size = 16,
  style,
  ...others
}: IconProps) {
  return (
    <svg
      style={{ width: rem(size), height: rem(size), ...style }}
      {...others}
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path
        opacity=".4"
        d="M0 152c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM0 256c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM0 360c0 13.3 10.7 24 24 24l40 0 0-48-40 0c-13.3 0-24 10.7-24 24zM128 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM232 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM336 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 424l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40-48 0zM448 128l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0zm0 104l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0zm0 104l0 48 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0z"
      />
      <path d="M128 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L128 64zm94.7 121.6l42 96 14 32c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2L239.5 304l-63.1 0-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l14-32 42-96c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9L190.5 272l35.1 0L208 231.9zM352 192l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16z" />
    </svg>
  );
});
